// extracted by mini-css-extract-plugin
export default {"not-available-blank":"index__not-available-blank--I4SC2","not-available-text":"index__not-available-text--f07zs"};